export const DEMO_PROJECTS = [
  {
    id: "p_shop",
    name: "SauceDemo Shop",
    base_url: "https://www.saucedemo.com",
    pages_found: 6,
    total_tests: 14,
    latest_status: "PASSED",
  },
  {
    id: "p_blog",
    name: "DevBlog",
    base_url: "https://example-blog.com",
    pages_found: 4,
    total_tests: 9,
    latest_status: null,
  },
  {
    id: "p_admin",
    name: "Admin Panel",
    base_url: "https://admin.example.com",
    pages_found: 8,
    total_tests: 22,
    latest_status: "FAILED",
  },
];

export function demoProject(id) {
  const found = DEMO_PROJECTS.find((p) => p.id === id);
  if (found) return found;
  return { id, name: "Demo Project", base_url: "https://demo.example.com", pages_found: 3 };
}

export function demoTestCases(id) {
  const pageUrls = {
    p_shop: [
      "/", "/inventory.html", "/cart.html", "/checkout-step-one.html",
      "/checkout-step-two.html", "/checkout-complete.html",
    ],
    p_blog: ["/", "/about", "/blog", "/contact"],
    p_admin: ["/login", "/dashboard", "/users", "/settings", "/reports", "/audit", "/api-keys", "/billing"],
  };
  const pages = pageUrls[id] || pageUrls.p_shop;
  const testCases = pages.flatMap((url, pi) => [
    { id: `tc_${id}_${pi}_1`, page_url: url, instruction: `Verify page ${url} loads correctly`, category: "navigation", expected_result: "Page loads with status 200" },
    { id: `tc_${id}_${pi}_2`, page_url: url, instruction: `Check all interactive elements on ${url}`, category: "functional", expected_result: "All elements respond correctly" },
  ]);
  return {
    total: testCases.length,
    test_cases: testCases,
    by_page: pages.map((url) => ({ page_url: url, count: 2 })),
    pages_with_tests: pages.length,
  };
}

export function demoRuns(id) {
  const runs = [
    { id: `r_${id}_1`, status: "PASSED", instruction: "Verify login page loads", url: "https://example.com/login", cost: 0.031, duration_seconds: 8.2, steps: [] },
    { id: `r_${id}_2`, status: "FAILED", instruction: "Log in with valid credentials", url: "https://example.com/login", cost: 0.055, bug: { severity: "critical", title: "Login button unresponsive", description: "Click on login button does not trigger form submission." }, duration_seconds: 15.7, steps: [] },
    { id: `r_${id}_3`, status: "PASSED", instruction: "Verify dashboard loads after login", url: "https://example.com/dashboard", cost: 0.028, duration_seconds: 6.4, steps: [] },
    { id: `r_${id}_4`, status: "RUNNING", instruction: "Check user profile page", url: "https://example.com/profile", cost: 0, duration_seconds: 0, steps: [] },
  ];
  return {
    total: 4,
    completed: 3,
    in_progress: 1,
    eta_seconds: 45,
    percent: 75,
    runs: runs,
  };
}
